import { Component } from '@angular/core';
import { ControlContainer, FormControl, FormGroup, FormGroupDirective } from '@angular/forms';
import { rangeValidator } from 'src/app/core/utils/utility.functions';


@Component({
  selector: 'app-payout-od-percent-range',
  templateUrl: './payout-od-percent-range.component.html',
  styleUrls: ['./payout-od-percent-range.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class PayoutOdPercentRangeComponent {
  form: FormGroup;

  rangeForm = new FormGroup({
    "from": new FormControl(),
    "to": new FormControl(),
  });

  constructor(private ctrlContainer: FormGroupDirective) { };

  ngOnInit(): void {
    this.form = this.ctrlContainer.form;

    this.rangeForm.controls['to'].addValidators(rangeValidator.bind(this, this.rangeForm));
    this.rangeForm.controls['from'].addValidators(rangeValidator.bind(this, this.rangeForm));

    if (this.form.controls['od_percent']) {
      this.rangeForm.patchValue(this.form.controls['od_percent'].value);
      this.form.removeControl('od_percent');
    }

    this.form.addControl('od_percent', this.rangeForm);
  }

  ngOnDestroy(): void {
    this.form.removeControl('od_percent');
  }
}
